__turbopack_context__.v({
  "className": "arbeitfont_5d2c581d-module__ZMdkwa__className",
  "variable": "arbeitfont_5d2c581d-module__ZMdkwa__variable",
});
